import React from 'react'
import Logo from './Logo'

const Header = () => {
  return (
    <header className="header">
      <Logo />
    </header>
  )
}

export default Header
